import { useEffect, useState } from 'react';
import { useSupabase } from '../context/SupabaseContext';
import type { Profile } from '../types';

export function useProfiles() {
  const { supabase } = useSupabase();
  const [profiles, setProfiles] = useState<Profile[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supabase) {
      setLoading(false);
      return;
    }

    const client = supabase;

    async function fetchProfiles() {
      setLoading(true);
      const { data, error } = await client
        .from('profiles')
        .select('*')
        .order('id', { ascending: true });

      if (error) {
        console.error('Error fetching profiles:', error);
      } else {
        setProfiles(data || []);
      }
      setLoading(false);
    }

    fetchProfiles();
  }, [supabase]);

  return { profiles, loading };
}